import { render, staticRenderFns } from "./FormInputSupportMethod.vue?vue&type=template&id=1efc37f2&scoped=true&lang=pug"
import script from "./FormInputSupportMethod.vue?vue&type=script&lang=ts"
export * from "./FormInputSupportMethod.vue?vue&type=script&lang=ts"
import style0 from "./FormInputSupportMethod.vue?vue&type=style&index=0&id=1efc37f2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1efc37f2",
  null
  
)

export default component.exports